/**
 * Mixin provides a pre filled input property
 *
 * @param name - the name of the computed propery to be injected in the component
 * @param preFilled - the pre filled value. Can be one of
 * - function callback that calculates the value
 * - name of another component property (a prop, data, or computed)
 * - a static value
 * @param prop - field an prop event is emitted to
 * @returns {{}|{data(): {}, computed: {}}}
 */
export default function preFilledInput (name, preFilled, prop) {
  const shadowVariableName = name + '_'
  const computed = {}

  computed[name] = {
    get: function () {
      if (this[shadowVariableName] !== null) {
        return this[shadowVariableName]
      }
      if (typeof preFilled === 'function') {
        return (this ? preFilled.bind(this) : preFilled)()
      }
      if (typeof this[preFilled] !== 'undefined') {
        return this[preFilled]
      }
      return preFilled
    },
    set: function (value) {
      this[shadowVariableName] = value
      if (typeof prop === 'string') {
        this.$emit(`update:${prop}`, value)
      }
    }
  }

  return {
    data () {
      const data = {}
      data[shadowVariableName] = null
      return data
    },
    computed
  }
}
